import { FC, useState } from 'react';

import { StyledChildrenContainer, StyledContainer, StyledExpandButton } from './DevToolsContainer.styles';
import { DevToolsContainerProps } from './DevToolsContainer.types';

const DevToolsContainer: FC<DevToolsContainerProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <StyledContainer>
      <StyledExpandButton
        css={{
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
        onClick={() => setIsOpen(!isOpen)}
      />
      <StyledChildrenContainer
        css={{
          visibility: isOpen ? 'visible' : 'hidden',
          width: isOpen ? '300px' : '2px',
        }}
      >
        {children}
      </StyledChildrenContainer>
    </StyledContainer>
  );
};

export default DevToolsContainer;
